import React from 'react';


// Change the icons, function names, and parameters 
// to fit your portfolio topic and schema.

import { CgPen, CgTrash } from "react-icons/cg";


function Recipe({ recipe, onEdit, onDelete }) {
    return (
        <tr>
            <td>{recipe.title}</td>
            <td>{recipe.serves}</td>
            <td>{recipe.date.slice(0,10)}</td>

            {/* Update these icons to something that matches your style. */}
            <td><CgTrash onClick={() => onDelete(recipe._id)} /></td>
            <td><CgPen onClick={() => onEdit(recipe)} /></td>
        </tr>
    );
}

export default Recipe;